import './NoteDrawer.scss';

/**
 * FootNote Properties
 */
export interface NoteDrawer {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NoteDrawer = ({ drawerOpen, setDrawerOpen }: NoteDrawer) => {
  return (
    <div
      className={`Turbo_ROI-drawer-backdrop
        ${drawerOpen ? 'opened' : 'closed'} Turbo_ROI-drawer-transition`}
      onClick={() => setDrawerOpen(false)}
    ></div>
  );
};

export default NoteDrawer;
